{
    "SchedulereportLabel": "Plan dit rapport:",
    "SchedulereportNotscheduledOptionLabel": "[Niet gepland]",
    "SchedulereportOnceOptionLabel": "Een keer",
    "SchedulereportHourlyOptionLabel": "per uur",
    "SchedulereportDailyOptionLabel": "Dagelijks",
    "SchedulereportWeeklyOptionLabel": "Wekelijks",
    "SchedulereportMonthlyOptionLabel": "Maandelijks",
    "SchedulereportResetButtonLabel": "Resetten",
    "SchedulereportPromptReset": "Weet u zeker dat u het schema opnieuw wilt instellen?",
    "SchedulereportPromptButtonConfirmLabel": "Bevestigen",
    "SchedulereportPromptButtonCancelLabel": "Annuleren",
    "ReportScheduling_SectionHeader": "Rapportplanning",
    "NAME": "ReportScheduling"
}